import { GAEvents } from '@/types/GAEvents';

export function reportGAEvent<K extends keyof GAEvents>(eventName: K, data: GAEvents[K]): void {
  window.gtag && window.gtag('event', eventName, { ...data, address: `address_${data.address || ''}` });
}
